import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Subject, takeUntil } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { AuthService } from './services/auth/auth.service';
import { StorageService } from './services/storage/storage.service';
import { FormattedOrganizationInRole } from './services/rbs/interfaces/formatted-organization-in-role.interface';
import { RbsService } from './services/rbs/rbs.service';
import { LCPUserService } from './shared/services/lcp-user/lcp-user.service';

@Component({
  imports: [CommonModule, MatProgressBarModule, RouterModule],
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _authenticationService = inject(AuthService);
  private readonly _lcpUserService = inject(LCPUserService);
  private readonly _oidcSecurityService = inject(OidcSecurityService);
  private readonly _rbsService = inject(RbsService);
  private readonly _storageService = inject(StorageService);

  private readonly _unsubscribeAll = new Subject<void>();

  ngOnInit() {
    this._oidcSecurityService
      .checkAuth()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe();
    this._authenticationService.isAuthenticatedAlert();
    this._authenticationService.getUserDataFromFortify();
    this.retrieveSessionData();
  }

  retrieveSessionData(): void {
    if (
      this._storageService.isExisted('Organization') &&
      this._storageService.isExisted('OrgInRole') &&
      this._storageService.isExisted('ServiceRole')
    ) {
      const orgInRole: FormattedOrganizationInRole =
        this._storageService.getItem<FormattedOrganizationInRole>('OrgInRole')!;

      this._rbsService.setSelectedRoleInOrganization(orgInRole);
      this._rbsService.setSelectedFormattedOrganizationInRole(orgInRole);
      this._lcpUserService.setUserTenantId(orgInRole.orgId);
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
